import {
  ListItem,
  Mats,
  ParagraphSmall,
  useStyletron,
} from "@mezo-org/mezo-clay"

export default function LeaderboardHeader({
  isMatsLeaderboard,
}: {
  isMatsLeaderboard: boolean
}) {
  const [css, theme] = useStyletron()

  return (
    <ListItem
      overrides={{
        Root: {
          style: () => ({
            height: "20px",
            background: "transparent",
            marginBottom: theme.sizing.scale300,
          }),
        },
        Content: {
          style: () => ({
            marginLeft: 0,
            paddingLeft: theme.sizing.scale600,
          }),
        },
      }}
    >
      <ParagraphSmall
        color={theme.colors.contentSecondary}
        width={theme.sizing.scale1600}
      >
        Rank
      </ParagraphSmall>
      <ParagraphSmall color={theme.colors.contentSecondary} flex={1}>
        Mezo ID
      </ParagraphSmall>
      <ParagraphSmall
        color={theme.colors.contentSecondary}
        width={theme.sizing.scale3200}
        className={css({
          width: theme.sizing.scale3200,
          justifyContent: "flex-end",
          display: "flex",
          alignItems: "center",
          gap: theme.sizing.scale100,
        })}
      >
        {isMatsLeaderboard ? (
          <>
            Total mats{" "}
            <Mats
              size={12}
              color={theme.colors.black}
              className={css({ marginBottom: "2px" })}
            />
          </>
        ) : (
          "Rank change"
        )}
      </ParagraphSmall>
    </ListItem>
  )
}
